import {useDispatch} from "react-redux";
import {useMarkAsReadMutation} from "../../../Store/Builder/messaging.api";

const useMarkAsRead = () => {
  const dispatch = useDispatch();
  const [markAsRead] = useMarkAsReadMutation();
  const create = (content) => {
    const body = {
      body: content,
    }
    markAsRead(body)
      .unwrap()
      .then(() => {
      })
      .catch(() => {
      });
  };

  return {
    create,
  };
};

export default useMarkAsRead;
